import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent, RmaIcons } from '@rma/generic/ui/icon';
import { PossessivePipe } from '@rma/generic/util/pipes/possesive';
import { AveragePriceExpectationResultType } from '../../domain/results';

export interface PriceExpectationViewModel {
  key: string;
  styles: string;
  icon: RmaIcons;
}

@Component({
  selector: 'rma-result-price-expectation',
  imports: [NgClass, RmaIconComponent, TranslocoModule, PossessivePipe],
  templateUrl: './price-expectation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceExpectationComponent implements OnChanges {
  @Input()
  result!: AveragePriceExpectationResultType;

  @Input()
  shortName!: string | undefined;

  priceExcpectationViewModel: PriceExpectationViewModel | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['result']) {
      this.priceExcpectationViewModel = this.getPriceExpectationViewModel(this.result);
    }
  }

  private getPriceExpectationViewModel(result: AveragePriceExpectationResultType): PriceExpectationViewModel | undefined {
    switch (result) {
      case 'Happy':
        return { key: result, styles: 'bg-blue-10 text-blue-50', icon: 'sentiment_satisfied_alt' };
      case 'VeryHappy':
        return { key: result, styles: 'bg-success-10 text-success-50', icon: 'sentiment_very_satisfied' };
      default:
        return undefined;
    }
  }
}
